import { RefresherCustomEvent } from '@ionic/angular';
import { createAction, props } from '@ngrx/store';

import { ProfileSearchEnum } from '../../enums/profile-search';
import {
  ProfileLocation,
  PropertyProfile,
  PropertyProfileHistoryItem,
  StoredPropertyProfile
} from '../models/property-profile.model';

export const geocodeAddressLocation = createAction(
  '[Property Profile] Geocode Address Location',
  props<{ payload: { address: string } }>()
);

export const geocodeCoordinatesLocation = createAction(
  '[Property Profile] Geocode Coordinates Location',
  props<{ payload: { focus: boolean; latLng: google.maps.LatLngLiteral } }>()
);

export const geocodeLocationSuccess = createAction(
  '[Property Profile] Geocode Location Success',
  props<{ payload: { result: google.maps.GeocoderResult } }>()
);

export const geocodeLocationFailure = createAction(
  '[Property Profile] Geocode Location Failure',
  props<{ payload: { error: Error } }>()
);

export const resetSearch = createAction('[Property Profile] Reset Search');

export const loadProfileByAddress = createAction(
  '[Property Profile] Load Profile By Address',
  props<{ payload: { address: string; searchType: ProfileSearchEnum; zip: string } }>()
);

export const loadProfileByAPN = createAction(
  '[Property Profile] Load Profile By APN',
  props<{
    payload: {
      apn: string;
      county: string;
      searchType: ProfileSearchEnum;
      state: string;
    };
  }>()
);

export const goToMultipleProfilesSelection = createAction(
  '[Property Profile] Go To Multiple Profiles Selection',
  props<{ payload: { locations: ProfileLocation[]; searchType: ProfileSearchEnum } }>()
);

export const loadProfileFailure = createAction(
  '[Property Profile] Load Profile Failure',
  props<{ payload: { error: Error } }>()
);

export const refreshKey = createAction('[Property Profile] Refresh Key');

export const refreshKeySuccess = createAction(
  '[Property Profile] Refresh Key Success',
  props<{ payload: { key: string | null } }>()
);

export const refreshKeyFailure = createAction(
  '[Property Profile] Refresh Key Failure',
  props<{ payload: { error: Error } }>()
);

export const resetKey = createAction('[Property Profile] Reset Key');

export const savePropertyProfileHistory = createAction(
  '[Property Profile] Save Property Profile History',
  props<{ payload: { propertyProfile: PropertyProfile; searchType: ProfileSearchEnum } }>()
);

export const savePropertyProfileHistoryFailure = createAction(
  '[Property Profile] Save Property Profile History Failure',
  props<{ payload: { error: Error } }>()
);

export const parseSavedPropertyProfile = createAction(
  '[Property Profile] Parse Saved Property Profile',
  props<{ payload: { id: string; propertyProfile: PropertyProfile; searchType: ProfileSearchEnum } }>()
);

export const setPropertyProfile = createAction(
  '[Property Profile/API] Set Property Profile',
  props<{ payload: { storedPropertyProfile: StoredPropertyProfile } }>()
);

export const setSelectPropertyProfile = createAction(
  '[Property Profile] Select Property Profile',
  props<{ payload: { storedPropertyProfile: StoredPropertyProfile } }>()
);

export const goToSelectedPropertyProfile = createAction(
  '[Property Profile] Go To Selected Profile',
  props<{ payload: { searchType: ProfileSearchEnum } }>()
);

export const emailPlatMap = createAction(
  '[Property Profile] Email Plat Map',
  props<{
    payload: {
      address: string;
      deliveryEmail: string;
      zip: string;
    };
  }>()
);

export const loadReportHtml = createAction(
  '[Property Profile] Load Report HTML',
  props<{
    payload: { reportId: string };
  }>()
);

export const loadReportHtmlSuccess = createAction(
  '[Property Profile] Load Report HTML Success',
  props<{
    payload: { reportHtml: string; reportId: string };
  }>()
);

export const loadReportHtmlFailure = createAction('[Property Profile] Load Report HTML Failure');

export const exportReportPdf = createAction(
  '[Property Profile] Export Report PDF',
  props<{
    payload: { address: string; reportId: string };
  }>()
);

export const updateReportExportOptions = createAction(
  '[Property Profile] Update Report Export Options',
  props<{
    payload: {
      isReportExportDetailsAndCharacteristicsVisible?: boolean;
      isReportExportPlatMapVisible?: boolean;
      isReportExportSaleInformationVisible?: boolean;
      isReportExportSchoolsVisible?: boolean;
      isReportExportTransactionHistoryVisible?: boolean;
      reportId: string;
    };
  }>()
);

export const resetReportOptions = createAction(
  '[Property Profile] Reset Report Options',
  props<{
    payload: {
      reportId: string;
    };
  }>()
);

export const updatePropertySearchCenterLocation = createAction(
  '[Property Profile] Update Search Center Location',
  props<{
    payload: { location: google.maps.LatLngLiteral };
  }>()
);

export const updatePropertySearchLocation = createAction(
  '[Property Profile] Update Search Location',
  props<{ payload: { address: string; location: google.maps.LatLngLiteral } }>()
);

export const searchByOwner = createAction(
  '[Property Profile] Search By Owner',
  props<{
    payload: {
      county: string;
      firstName: string;
      lastName: string;
      state: string;
      zip: string;
    };
  }>()
);

export const emailDocument = createAction(
  '[Property Profile] Email Document',
  props<{
    payload: {
      apn: string;
      city?: string;
      cmtIdentifier?: string;
      documentNumber: string;
      documentType: string;
      email: string;
      fips: string;
      message: string;
      recodingDate: string;
      stateCode?: string;
      streetAddress?: string;
      subject: string;
    };
  }>()
);

export const loadProfileHistory = createAction(
  '[Property Profile] Load Profile History',
  props<{ payload: { ignoreLoader?: boolean; refreshedCustomEvent?: RefresherCustomEvent } }>()
);

export const loadProfileHistorySuccess = createAction(
  '[Property Profile] Load Profile History Success',
  props<{ payload: PropertyProfileHistoryItem[] }>()
);

export const loadProfileHistoryFailure = createAction(
  '[Property Profile] Load Profile History Failure',
  props<{ payload: { error: Error } }>()
);

export const deleteProfileHistoryItem = createAction(
  '[Property Profile] Delete Profile History Item',
  props<{ id: string }>()
);

export const deleteProfileHistoryItemSuccess = createAction(
  '[Property Profile] Delete Profile History Item Success',
  props<{ payload: { id: string } }>()
);

export const deleteProfileHistoryItemFailure = createAction(
  '[Property Profile] Delete Profile History Item Failure',
  props<{ payload: { error: Error } }>()
);

export const loadProfileHistoryItem = createAction(
  '[Property Profile] Load Profile History Item',
  props<{ payload: { id: string } }>()
);

export const loadProfileHistoryItemFailure = createAction(
  '[Property Profile] Load Profile History Item Failure',
  props<{ payload: { error: Error } }>()
);
